<!-- <mat-card class="mat-elevation-z8 mt-16"> -->
  <div class="row justify-between items-center bb-1 not-bb-last" *ngFor="let n of numSequence(rows)">
    <app-skeleton-text *ngFor="let n of numSequence(columns)" height="10px" width="100px"></app-skeleton-text>
  </div>
<!-- </mat-card> -->
